module.exports = __webpack_public_path__ + "static/media/Brand.09f73e6a.png";